import React, { useState,useContext } from "react";
import { withStyles } from "@mui/styles";
import { makeStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import EditIcon from "@mui/icons-material/Edit";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import EditMetersDialog from "./EditMetersDialog";
import Tooltip from "@mui/material/Tooltip";
import Button from "components/CustomButtons/Button.js";
import axios from "axios";
import { updateAccountMeters } from "services/ConfigServices";
import UserService from "services/UserService";
import { NotificationManager } from "react-notifications";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

export default function DeleteMeters({ refetch, meters, disabled, energy }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const deleteMetersFunction = (row) => async () => {
    const deleted = meters.map((meter) => meter.uuid);
    axios
      .put(
        updateAccountMeters("delete",chartIdGroup,energy),
        {
          meters:deleted
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `Les compteurs ont été supprimés`
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };


  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <Tooltip title="Supprimer la sélection">
        <CustomDeleteButton
          deleteTitle={"Suppression des compteurs"}
          deleteSubTitle={`Êtes-vous sûr de vouloir supprimer les compteurs sélectionnés.`}
          handleSupprimer={deleteMetersFunction()}
          disabled={disabled}
        />
      </Tooltip>
    </div>
  );
}
